import { c as _c } from "react/compiler-runtime";
import { Box, Link, Typography } from '@mui/material';
import { BEST_CREDIT_CARDS_HUB, type BreadcrumbData, type BreadcrumbSource, CREDIT_CARDS_REVIEWS_HUB, chevronSize, HOME_PAGE_URL } from './constants';
const BreadcrumbPath = t0 => {
  const $ = _c(16);
  const {
    pathColors,
    source,
    slug
  } = t0;
  let breadcrumbData;
  if (source === "ROUNDUPS" && slug) {
    breadcrumbData = BEST_CREDIT_CARDS_HUB;
  } else {
    if (source === "REVIEWS") {
      breadcrumbData = CREDIT_CARDS_REVIEWS_HUB;
    }
  }
  if (!breadcrumbData) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: {
        xs: "inline-block",
        sm: "inline-block"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Box component="li" aria-hidden="true" role="presentation" sx={t1}><span className="mask-icon mask-icon-chevron-right" style={{
        width: chevronSize,
        height: chevronSize
      }} /></Box>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: {
        xs: "flex",
        sm: "flex"
      },
      alignItems: "center"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = `${HOME_PAGE_URL}${breadcrumbData.link}`;
  let t5;
  if ($[3] !== pathColors.hoverColor) {
    t5 = {
      color: pathColors.hoverColor,
      textDecoration: "underline"
    };
    $[3] = pathColors.hoverColor;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== pathColors.color || $[6] !== t5) {
    t6 = {
      color: pathColors.color,
      "&:hover": t5
    };
    $[5] = pathColors.color;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== breadcrumbData.label || $[9] !== breadcrumbData.linkTitle || $[10] !== t4 || $[11] !== t6) {
    t7 = <Link aria-label={breadcrumbData.linkTitle} href={t4} fontWeight={700} fontSize={10} sx={t6}>{breadcrumbData.label}</Link>;
    $[8] = breadcrumbData.label;
    $[9] = breadcrumbData.linkTitle;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== breadcrumbData.title || $[14] !== t7) {
    t8 = <>{t2}<Box component="li" sx={t3}><Typography variant="breadcrumb" title={breadcrumbData.title} data-testid="breadcrumb-text">{t7}</Typography></Box></>;
    $[13] = breadcrumbData.title;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default BreadcrumbPath;